import Api from '@/services/Api'
import LocalStorage from '@/services/LocalStorageService'

const root = 'consultaapilib'
const clientRoot = () => `${LocalStorage.getClientPrefix()}/consultaapilib`

class ConsultaApiService {
  about () {
    return Api().get(`${clientRoot()}/about`)
  }

  insert (item) {
    return Api().post(root, item)
  }

  update (item) {
    return Api().put(root, item)
  }

  findAll () {
    return Api().get(clientRoot())
  }

  delete ({ nameGetMethod }) {
    return Api().delete(`${clientRoot()}/${nameGetMethod}`)
  }

  findById ({ nameGetMethod }) {
    const url = `${clientRoot()}/${nameGetMethod}`
    return Api().get(url)
  }
}

export default new ConsultaApiService()
